export function coreRoutes() {
  this.route('authorize');
  this.route('login');
  this.route('account');
  this.route('not-found', { path: '/*path' });
}

export { default as AppRoute } from './routes/application.js';
export { default as AccountRoute } from './routes/account.js';
export { default as AuthorizeRoute } from './routes/authorize.js';
export { default as LoginRoute } from './routes/login.js';
export { default as NotFoundRoute } from './routes/not-found.js';
